import { ComponentType } from 'react';
import { BaseGuard, Guard } from './BaseGuard';

export const AdminRouteGuard: Guard = <T extends {}>(Page: ComponentType<T>) =>
    BaseGuard(Page, ({ isAdmin }) => !isAdmin);
